export default "__VITE_ASSET__ClIaiBoD__"